export const MAKE_MY_TRIP_TRAINS = "MakeMyTrip - Trains";
export const RAIL_RAIL_BOOKING = "Rail, Rail Booking";
export const POKUS_WEB_LOCAL_STORAGE_KEY = "POKUS_WEB_LOCAL_STORAGE";
